export const PaymentStatus = {
	PENDING: "Pendiente",
	APPROVED: "Aprobado",
	REJECTED: "Rechazado",
} as const;

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

// ==========================================
// SUB-TYPES
// ==========================================
export interface PaymentOrderSummary {
	id: number;
	code_order: string;
	status_order: string;
	date_initial_order: string;
	quotations: Array<{
		proposed_price: number;
	}>;
}

export interface PaymentExchangeRateResponse {
	usd_to_bs: number;
	source: string;
	fetched_at: string;
}

export interface PaymentMethodRelation {
	id: number;
	name_method: string;
}

export interface PaginatedResponse<T> {
	items: T[];
	meta: {
		pagination: {
			totalItems: number;
			page: number;
			pageSize: number;
			totalPages: number;
		};
	};
}

// ==========================================
// RESPONSE TYPE
// ==========================================
export interface PaymentResponse {
	type: string;
	id: number;
	amount_payment: number;
	rate_payment: number;
	from_account: string;
	to_account: string;
	payment_support: string | null;
	payment_status: PaymentStatus;
	date_payment: string;
	date_approval_payment: string | null;
	date_rejection_payment: string | null;
	rejection_reason_payment: string | null;
	created_at: string;
	order: PaymentOrderSummary;
	methods: PaymentMethodRelation;
}

// ==========================================
// PAYLOAD TYPES
// ==========================================
export interface CreatePaymentPayload {
	order_id: number;
	method_id: number;
	amount_payment: number;
	from_account: string;
	to_account: string;
	payment_support?: string;
	date_payment?: Date | string;
}

export interface UpdatePaymentPayload {
	order_id?: number;
	method_id?: number;
	amount_payment?: number;
	from_account?: string;
	to_account?: string;
	payment_status?: PaymentStatus;
	date_payment?: Date | string;
	date_approval_payment?: Date | string;
	date_rejection_payment?: Date | string;
	rejection_reason_payment?: string | null;
	notify_client_email?: boolean;
}
